/**
 * Vrátí řetězec s cestou souboru
 * @param path
 * @returns {string}
 */
export function getFilePath(path) {
    const file = path.replace(/^.*[\\\/]/, '');

    return path.substring(0, path.indexOf(file));
}
